/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NormativeDocumentVersionFieldsOneOf { 
    deleted?: boolean;
    deletedOn?: boolean;
    deletedBy?: boolean;
    createdOn?: boolean;
    modifiedOn?: boolean;
    createdBy?: boolean;
    modifiedBy?: boolean;
    id?: boolean;
    documentId?: boolean;
    version?: boolean;
    versionMajor?: boolean;
    versionMinor?: boolean;
    folderFileId?: boolean;
    mimeType?: boolean;
    fileSize?: boolean;
    status?: boolean;
    changeSummary?: boolean;
    publishedOn?: boolean;
    effectiveOn?: boolean;
    approvedBy?: boolean;
    approvedOn?: boolean;
}

